(function () {
  const html = document.documentElement;
  const drawer = document.getElementById('GlobalDrawer');
  if (!drawer) return;

  const panel = drawer.querySelector('.global-drawer__panel');
  const closeBtn = drawer.querySelector('[data-action="close-global-drawer"]');
  const globalLinks = Array.from(
    document.querySelectorAll('[data-action="toggle-global"]')
  );

  let removeOutsideClickListener = null;
  let savedScrollPosition = 0;

  function addOutsideClickListener() {
    const handler = (e) => {
      if (!drawer.classList.contains('is-open')) return;
      if (panel && panel.contains(e.target)) return;
      if (e.target.closest && e.target.closest('[data-action="toggle-global"]'))
        return;
      if (panel.contains(e.target)) return;
      close();
    };
    document.addEventListener('click', handler, { capture: true });
    return () =>
      document.removeEventListener('click', handler, { capture: true });
  }

  function setGlobalButtonsAriaExpanded(isExpanded) {
    try {
      document
        .querySelectorAll('[data-action="toggle-global"]')
        .forEach((btn) => {
          btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        });
    } catch {}
  }

  const setTop = () => {
    const topEl =
      document.querySelector('.site-header__top') ||
      document.querySelector('.site-header');
    const rect = topEl ? topEl.getBoundingClientRect() : { bottom: 0 };
    const h = Math.max(0, Math.round(rect.bottom));
    drawer.style.top = h + 'px';
    drawer.style.height = `calc(100% - ${h}px)`;
    drawer.style.bottom = 'auto';
    panel.style.top = '0px';
    panel.style.height = '100%';
  };
  setTop();
  window.addEventListener('load', setTop);
  window.addEventListener('resize', setTop);
  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(setTop);
    const headerTop =
      document.querySelector('.site-header__top') ||
      document.querySelector('.site-header');
    headerTop && ro.observe(headerTop);
  }

  const isMobile =
    window.__isMobile ||
    (() => window.matchMedia('(max-width: 1024px)').matches);

  const open = () => {
    drawer.hidden = false;
    drawer.offsetHeight;
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
    });
    html.classList.add('global-open');
    if (isMobile()) {
      savedScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      document.body.style.top = `-${savedScrollPosition}px`;
    }
    setGlobalButtonsAriaExpanded(true);
    if (window.__bringDrawerToFront) window.__bringDrawerToFront(drawer);
    if (removeOutsideClickListener) removeOutsideClickListener();
    removeOutsideClickListener = addOutsideClickListener();
  };
  const close = () => {
    drawer.classList.remove('is-open');
    html.classList.remove('global-open');
    if (isMobile()) {
      document.body.style.top = '';
      window.scrollTo(0, savedScrollPosition);
    }
    setGlobalButtonsAriaExpanded(false);
    if (removeOutsideClickListener) {
      removeOutsideClickListener();
      removeOutsideClickListener = null;
    }
    drawer.addEventListener('transitionend', () => (drawer.hidden = true), {
      once: true,
    });
  };

  globalLinks.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      if (drawer.classList.contains('is-open')) {
        close();
      } else {
        open();
      }
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', close);
  }
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  document.addEventListener('shopify:section:select', (event) => {
    if (!(window.Shopify && Shopify.designMode)) return;
    const sectionId = event?.detail?.sectionId;
    const selectedSection = sectionId
      ? document.getElementById(`shopify-section-${sectionId}`)
      : document.querySelector('.shopify-section-selected');
    if (!selectedSection) return;

    const sectionType = selectedSection.getAttribute('data-section-type');
    const isGlobalDrawerSection =
      sectionType === 'global-drawer' ||
      selectedSection.contains(drawer) ||
      !!selectedSection.querySelector('#GlobalDrawer');

    if (isGlobalDrawerSection) {
      open();
    } else {
      if (drawer.classList.contains('is-open')) {
        close();
      }
    }
  });

  document.addEventListener('shopify:section:deselect', () => {
    if (!(window.Shopify && Shopify.designMode)) return;
    if (drawer.classList.contains('is-open')) {
      close();
    }
  });
})();
